import axios from 'axios';

const lang = 'id';

export const sportalokaClient = axios.create({
  baseURL: process.env.REACT_APP_CORE_SERIVE_API_URL ?? ''
});

// Auth
export const getBalance = async () => {
  return await sportalokaClient.get('admin/transaction/balance');
};

// Auth
export const signinAdmin = async (body) => {
  const { email, password } = body;
  return await sportalokaClient.post('admin/auth/signin', { email, password });
};

export const getTenantBalance = async (tenant_id) => {
  return await sportalokaClient.get('admin/tenant/' + tenant_id + 'balance/');
};

export const declineWithdrawlRequest = async (withdrawl_id, reason) => {
  return await sportalokaClient.post('admin/withdrawl/decline/' + withdrawl_id, { reason });
};

export const declineRefundRequest = async (refund_id, reason) => {
  return await sportalokaClient.post('admin/refund/decline/' + refund_id, { reason });
};

export const completeWithdrawlRequest = async (withdrawl_id) => {
  return await sportalokaClient.post('admin/withdrawl/complete/' + withdrawl_id);
};

export const processWithdrawlRequest = async (withdrawl_id) => {
  return await sportalokaClient.post('admin/withdrawl/process/' + withdrawl_id);
};

export const completeRefundRequest = async (refund_id) => {
  return await sportalokaClient.post('admin/refund/complete/' + refund_id);
};

export const processRefundRequest = async (refund_id) => {
  return await sportalokaClient.post('admin/refund/process/' + refund_id);
};

export const getWithdrawlDetail = async (withdrawl_id) => {
  return await sportalokaClient.get('admin/withdrawl/detail/' + withdrawl_id);
};

export const getRefundDetail = async (refund_id) => {
  return await sportalokaClient.get('admin/refund/detail/' + refund_id);
};

export const searchWithdrawls = async (query) => {
  return await sportalokaClient.get('admin/withdrawl/search?' + query);
};

export const searchRefunds = async (query) => {
  return await sportalokaClient.get('admin/refund/search?' + query);
};

export const inviteUser = async (body) => {
  const { email, type, fullname } = body;

  return await sportalokaClient.post('admin/auth/invite-admin', { email, type, fullname });
};

export const getTenantRequest = async (query) => {
  return await sportalokaClient.get('admin/tenant/requests?' + query);
};

export const refreshToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  const sessionId = localStorage.getItem('sessionId');

  if (!refreshToken) {
    throw Error('refresh token is not provided');
  }
  if (!sessionId) {
    throw Error('session id is not provided');
  }

  return await sportalokaClient.post('auth/refresh-token', {
    refresh_token: refreshToken,
    session_id: sessionId
  });
};

export const processTenantRequest = async (id) => {
  return await sportalokaClient.post('admin/tenant/process/' + id);
};

export const rejectTenantRequest = async (id, notes) => {
  return await sportalokaClient.post('admin/tenant/reject/' + id, { notes });
};

export const approveTenantRequest = async (id) => {
  return await sportalokaClient.post('admin/tenant/approve/' + id);
};

export const createArticle = async (data) => {
  return await sportalokaClient.post('admin/article/create/', data);
};

export const updateArticle = async (id, data) => {
  return await sportalokaClient.post('admin/article/update/' + id, data);
};

export const detailArticle = async (id) => {
  return await sportalokaClient.get('article/detail/' + id);
};

export const tenantActivation = async (id) => {
  return await sportalokaClient.post('admin/tenant/activation/' + id);
};

export const getTenantRequestDetail = async (id) => {
  return await sportalokaClient.get('admin/tenant/request-detail/' + id);
};

export const changePassword = async (body) => {
  const { old_password, password } = body;

  return await sportalokaClient.post('auth/change-password', {
    old_password,
    password,
    provider: 'direct'
  });
};

export const forgotPassword = async (email) => {
  return await sportalokaClient.post('auth/forgot-password', {
    email,
    provider: 'direct',
    continueUrl: process.env.REACT_APP_CORE_SERIVE_API_URL ?? 'http://localhost:3007'
  });
};

export const signout = async () => {
  return await sportalokaClient.post('auth/signout');
};

export const createProvince = async (name) => {
  return await sportalokaClient.post('admin/province/create', { name });
};

export const addTenantFee = async (tenant_id, fee_type, fee_value) => {
  return await sportalokaClient.post(`admin/tenant/${tenant_id}/fee/add`, { fee_type, fee_value });
};

export const updateGlobalConfig = async (payload) => {
  return await sportalokaClient.post(`admin/global-config/update`, payload);
};

export const getCurrentTenantFee = async (tenant_id) => {
  return await sportalokaClient.get(`admin/tenant/${tenant_id}/fee/current`);
};

export const getTenantFeeHistory = async (tenant_id) => {
  return await sportalokaClient.get(`admin/tenant/${tenant_id}/fee/history`);
};

export const getGlobalConfig = async () => {
  return await sportalokaClient.get(`admin/global-config`);
};

export const getPaymentMethods = async () => {
  return await sportalokaClient.get(`payment/payment-methods`);
};

export const updatePaymentChannel = async (id, status) => {
  return await sportalokaClient.post('admin/payment/payment-channel/update/' + id, { status });
};

export const updateProvince = async (id, name) => {
  return await sportalokaClient.post('admin/province/update/' + id, { name });
};

export const searchProvinces = async (query) => {
  return await sportalokaClient.get('province/search?' + query);
};

export const searchArticles = async (query) => {
  return await sportalokaClient.get('article/search?' + query);
};

export const deleteProvince = async (id) => {
  return await sportalokaClient.post('admin/province/delete/' + id);
};

export const createCity = async (province_id, name) => {
  return await sportalokaClient.post('admin/city/create', { province_id, name });
};

export const updateCity = async (id, name, province_id) => {
  return await sportalokaClient.post('admin/city/update/' + id, { name, province_id });
};

export const searchCities = async (query) => {
  return await sportalokaClient.get('city/search?' + query);
};

export const getIncome = async (query) => {
  return await sportalokaClient.get('admin/transaction/income?' + query);
};

export const getRefund = async (query) => {
  return await sportalokaClient.get('admin/transaction/refund?' + query);
};

export const getExecutedGuests = async (query) => {
  return await sportalokaClient.get('admin/booking/count-executed-guests?' + query);
};

export const getTotalUsers = async () => {
  return await sportalokaClient.get('admin/user/total-users');
};

export const getTotalTenants = async () => {
  return await sportalokaClient.get('admin/tenant/total-tenants');
};

export const getWithdrawl = async (query) => {
  return await sportalokaClient.get('admin/transaction/withdrawl?' + query);
};

export const getExpense = async (query) => {
  return await sportalokaClient.get('admin/transaction/expense?' + query);
};

export const getCashflow = async (query) => {
  return await sportalokaClient.get('admin/transaction/cashflow?' + query);
};

export const deleteCity = async (id) => {
  return await sportalokaClient.post('admin/city/delete/' + id);
};

export const createFacility = async (icon, name) => {
  return await sportalokaClient.post('admin/facility/create', { icon, name });
};

export const updateFacility = async (id, name, icon) => {
  return await sportalokaClient.post('admin/facility/update/' + id, { name, icon });
};

export const searchFacilities = async (query) => {
  return await sportalokaClient.get('facility/search?' + query);
};

export const deleteFacility = async (id) => {
  return await sportalokaClient.post('admin/facility/delete/' + id);
};

export const upload = async (formData) => {
  return await sportalokaClient.post('uploader/upload', formData);
};

export const createVoucher = async (payload) => {
  return await sportalokaClient.post('admin/voucher', payload);
};

export const detailVoucher = async (id) => {
  return await sportalokaClient.get('admin/voucher/' + id);
};

export const updateVoucher = async (id, payload) => {
  return await sportalokaClient.patch('admin/voucher/' + id, payload);
};

export const searchVouchers = async (query) => {
  return await sportalokaClient.get('admin/voucher?' + query);
};

export const deleteVoucher = async (id) => {
  return await sportalokaClient.delete('admin/voucher/' + id);
};

export const searchBookings = async (query) => {
  return await sportalokaClient.get('admin/booking/search?' + query);
};

export const getBookingDetail = async (booking_id) => {
  return await sportalokaClient.get('admin/booking/detail/' + booking_id);
};

export const fetchGuestsCosts = async (booking_id) => {
  return await sportalokaClient.get('admin/booking/guest-costs/get/' + booking_id);
};

export const refreshPaymentStatusApi = async (booking_id) => {
  return await sportalokaClient.post('admin/payment/refresh/' + booking_id);
};

export const searchUsers = async (query) => {
  return await sportalokaClient.get('admin/user/search?' + query);
};

export const changeUserStatus = async (id) => {
  return await sportalokaClient.post('admin/user/update-status/' + id);
};
